import React from 'react';
import { useTranslate } from 'react-translate';
import { Button } from 'reactstrap';
const BtnReply = ({ mobile, setShowForm, setReply, setResend, disabled }) => {
  const t = useTranslate('messages');
  return (
    <Button
      className="btn-reply"
      color="info"
      size="sm"
      name="forward-message-btn"
      onClick={() => {
        setShowForm(true);
        setResend(true);
        setReply(false);
      }}
      disabled={disabled}
    >
      {!mobile && t('btn-forward')} <span className="icon-forward"></span>
    </Button>
  );
};

export default BtnReply;
